import { BaseModel, convertToArrayModels, convertToModel, fillOwnProperties, registerModel } from '~/shared/model'
import { toCroppedImage } from '~/shared/utils/image'
import { isUnknownObject } from '~/shared/utils/guards'
import ArticleComment from './ArticleComment'
import ArticleRubric from './ArticleRubric'
import ArticleTag from './ArticleTag'

export default class Article extends BaseModel {
  static override constructorName = 'Article'

  id: number = 0
  name: string = ''
  slug: string = ''
  image: string = ''
  'content_html': string = ''
  'published_at': string = ''
  'created_at': string = ''
  'author_name': string = ''
  'is_show_comments': boolean = false
  'news_tags': ArticleTag[] = []
  'news_rubric': ArticleRubric | null = null
  comments: ArticleComment[] = []

  constructor(data?: unknown) {
    super(data)
    if (!isUnknownObject(data)) return

    fillOwnProperties(this, data, ['news_tags', 'news_rubric', 'comments'])

    this.image = toCroppedImage(this.image)

    this.news_rubric = convertToModel(data.news_rubric, ArticleRubric)
    this.news_tags = convertToArrayModels(data.news_tags, ArticleTag)
    this.comments = convertToArrayModels(data.comments, ArticleComment)
  }

  get publicationDate(): string {
    return this.published_at || this.created_at
  }
}

registerModel(Article)
